import React from 'react';
import { Link } from 'react-router-dom';

/* ─────────────────────────────────────────────────────────────────────────────
   MODOS DE VENTA · GUÍA COMERCIAL INTERNA
   Documento interno para el equipo de ventas VACWAY.
   Visible solo para ADMIN tipo MASTER o COMERCIAL.
───────────────────────────────────────────────────────────────────────────── */

const C = {
  dia:      '#0284c7',
  abertura: '#7c3aed',
  horas:    '#dc2626',
};

const rgba = (hex, a) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r},${g},${b},${a})`;
};

/* ── CSS ── */
const CSS = `
  .smv-page { width: 100%; font-family: inherit; color: #1e293b; box-sizing: border-box; }
  .smv-hero { border-radius: 14px; padding: 40px 36px; margin-bottom: 28px; color: #fff; position: relative; overflow: hidden;
    background: linear-gradient(135deg, #0c4a6e 0%, #0284c7 55%, #38bdf8 100%); }
  .smv-hero-badge { display: inline-block; background: rgba(255,255,255,0.16); border: 1px solid rgba(255,255,255,0.3);
    border-radius: 20px; padding: 4px 14px; font-size: 11px; font-weight: 700; letter-spacing: 1.1px; text-transform: uppercase; margin-bottom: 14px; }
  .smv-hero h1 { font-size: 30px; font-weight: 800; margin: 0 0 10px; line-height: 1.25; }
  .smv-hero p { font-size: 15px; opacity: 0.9; max-width: 680px; line-height: 1.6; margin: 0; }
  .smv-hero-actions { margin-top: 18px; }
  .smv-hero-btn { display: inline-flex; align-items: center; gap: 8px; padding: 10px 24px; border-radius: 8px;
    background: #fff; border: none; color: #0369a1;
    font-size: 13.5px; font-weight: 700; text-decoration: none; transition: all 0.2s; cursor: pointer;
    box-shadow: 0 2px 8px rgba(0,0,0,0.12); }
  .smv-hero-btn:hover { background: #f0f9ff; box-shadow: 0 4px 14px rgba(0,0,0,0.18); transform: translateY(-1px); }
  .smv-golden { display: flex; align-items: center; gap: 18px; padding: 18px 24px; margin-bottom: 36px;
    background: linear-gradient(135deg, #fefce8 0%, #fef9c3 50%, #fef08a 100%); border: 1px solid #fbbf24; border-left: 5px solid #d97706; border-radius: 10px; }
  .smv-golden-icon { font-size: 32px; flex-shrink: 0; }
  .smv-golden-label { font-size: 11px; font-weight: 800; text-transform: uppercase; letter-spacing: 1.1px; color: #b45309; margin-bottom: 2px; }
  .smv-golden-title { font-size: 18px; font-weight: 800; color: #78350f; margin-bottom: 3px; }
  .smv-golden-text { font-size: 13px; color: #92400e; line-height: 1.55; }
  .smv-section-title { font-size: 20px; font-weight: 800; color: #0f172a; margin: 0 0 4px; }
  .smv-section-sub { font-size: 13.5px; color: #64748b; margin: 0 0 18px; }
  .smv-concepts { display: grid; grid-template-columns: repeat(3, 1fr); gap: 14px; margin-bottom: 36px; }
  .smv-concept-card { background: #fff; border: 1px solid #e2e8f0; border-radius: 10px; padding: 20px; }
  .smv-concept-card:hover { border-color: #cbd5e1; box-shadow: 0 2px 8px rgba(0,0,0,0.04); }
  .smv-concept-icon { font-size: 26px; margin-bottom: 8px; }
  .smv-concept-title { font-size: 14px; font-weight: 700; color: #0f172a; margin-bottom: 5px; }
  .smv-concept-body { font-size: 13px; color: #475569; line-height: 1.6; }
  .smv-order-strip { display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px; margin-bottom: 36px; }
  .smv-order-item { display: flex; align-items: center; gap: 12px; border-radius: 10px; padding: 14px 16px; }
  .smv-order-num { width: 34px; height: 34px; border-radius: 50%; color: #fff; font-weight: 900; font-size: 15px;
    display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
  .smv-order-label { font-weight: 700; font-size: 13.5px; display: flex; align-items: center; gap: 5px; }
  .smv-order-sub { font-size: 11.5px; color: #64748b; margin-top: 1px; }
  .smv-modes-list { display: flex; flex-direction: column; gap: 20px; margin-bottom: 36px; }
  .smv-modecard { background: #fff; border: 1px solid #e2e8f0; border-radius: 12px; padding: 28px; display: flex; flex-direction: column; }
  .smv-modecard-header { display: flex; align-items: flex-start; gap: 16px; margin-bottom: 14px; }
  .smv-modecard-icon { width: 50px; height: 50px; border-radius: 12px; display: flex; align-items: center; justify-content: center; font-size: 24px; flex-shrink: 0; }
  .smv-modecard-meta { display: flex; flex-wrap: wrap; align-items: center; gap: 8px; margin-bottom: 5px; }
  .smv-modecard-num { font-size: 11px; font-weight: 800; letter-spacing: 1.1px; text-transform: uppercase; }
  .smv-modecard-badge { font-size: 11px; font-weight: 700; padding: 3px 10px; border-radius: 20px; }
  .smv-modecard h3 { font-size: 19px; font-weight: 800; margin: 0 0 4px; color: #0f172a; }
  .smv-modecard-stars { display: flex; align-items: center; gap: 5px; }
  .smv-modecard-stars-label { font-size: 12px; color: #64748b; }
  .smv-modecard-desc { font-size: 14px; color: #475569; line-height: 1.65; margin: 0 0 16px; }
  .smv-modecard-body { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; }
  .smv-modecard-left { }
  .smv-modecard-right { }
  .smv-label { font-size: 11px; font-weight: 800; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 8px; }
  .smv-feature { display: flex; align-items: flex-start; gap: 8px; margin-bottom: 7px; }
  .smv-tick { display: inline-flex; align-items: center; justify-content: center; width: 18px; height: 18px;
    border-radius: 50%; color: #fff; font-size: 10px; font-weight: 900; flex-shrink: 0; margin-top: 1px; }
  .smv-feature-text { font-size: 13px; color: #1e293b; line-height: 1.5; }
  .smv-infobox { border-radius: 8px; padding: 10px 14px; margin: 8px 0; font-size: 13px; line-height: 1.55; }
  .smv-infobox-info { background: #eff6ff; border: 1px solid #93c5fd; color: #1e40af; }
  .smv-infobox-warning { background: #fffbeb; border: 1px solid #fcd34d; color: #92400e; }
  .smv-infobox-success { background: #f0fdf4; border: 1px solid #86efac; color: #15803d; }
  .smv-infobox-danger { background: #fef2f2; border: 1px solid #fca5a5; color: #991b1b; }
  .smv-tags { display: flex; flex-wrap: wrap; gap: 6px; margin-bottom: 14px; }
  .smv-tag { display: inline-flex; align-items: center; padding: 3px 10px; border-radius: 20px; font-size: 12px; font-weight: 600; }
  .smv-rec-box { border-radius: 8px; padding: 14px 16px; }
  .smv-rec-text { font-size: 13px; line-height: 1.6; }
  .smv-divider { border: none; border-top: 1px solid #e2e8f0; margin: 16px 0; }
  .smv-table-wrap { overflow-x: auto; border-radius: 10px; border: 1px solid #e2e8f0; margin-bottom: 36px; -webkit-overflow-scrolling: touch; }
  .smv-table { width: 100%; border-collapse: collapse; min-width: 700px; }
  .smv-table th { padding: 12px 14px; text-align: left; font-size: 12px; font-weight: 700; }
  .smv-table td { padding: 9px 14px; font-size: 13px; border-bottom: 1px solid #f1f5f9; vertical-align: middle; }
  .smv-table thead th:first-child { background: #f8fafc; color: #64748b; text-transform: uppercase; letter-spacing: 0.8px; border-bottom: 2px solid #e2e8f0; }
  .smv-guide-card { background: #fff; border: 1px solid #e2e8f0; border-radius: 10px; padding: 22px 24px; margin-bottom: 16px; }
  .smv-guide-title { font-size: 15px; font-weight: 700; color: #0f172a; margin-bottom: 16px; }
  .smv-qblock { margin-bottom: 14px; }
  .smv-qblock-q { font-weight: 700; font-size: 13.5px; color: #0f172a; margin-bottom: 7px; }
  .smv-qblock-answers { display: flex; flex-direction: column; gap: 5px; padding-left: 16px; }
  .smv-qblock-row { display: flex; align-items: flex-start; gap: 8px; flex-wrap: wrap; }
  .smv-qblock-cond { border-radius: 4px; padding: 2px 8px; font-size: 11px; font-weight: 700; color: #fff; flex-shrink: 0; white-space: nowrap; }
  .smv-qblock-rec { font-size: 13px; color: #334155; line-height: 1.5; }
  .smv-step { display: flex; gap: 14px; margin-bottom: 16px; }
  .smv-step:last-child { margin-bottom: 0; }
  .smv-step-num { width: 30px; height: 30px; border-radius: 50%; color: #fff; font-weight: 900; font-size: 14px;
    display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
  .smv-step-title { font-weight: 700; font-size: 13.5px; margin-bottom: 3px; }
  .smv-step-text { font-size: 13px; font-style: italic; line-height: 1.55; color: #334155; }
  .smv-danger-box { background: #fef2f2; border: 1px solid #fecaca; border-radius: 10px; padding: 18px 22px; margin-bottom: 36px; }
  .smv-danger-title { font-size: 14px; font-weight: 700; color: #991b1b; margin-bottom: 10px; }
  .smv-danger-item { display: flex; align-items: flex-start; gap: 8px; margin-bottom: 6px; }
  .smv-danger-arrow { color: #dc2626; font-weight: 900; font-size: 13px; flex-shrink: 0; margin-top: 1px; }
  .smv-danger-text { font-size: 13px; color: #7f1d1d; line-height: 1.5; }
  .smv-exec { background: #fff; border: 1px solid #e2e8f0; border-radius: 12px; padding: 24px 28px; }
  .smv-exec-label { font-size: 11px; font-weight: 800; text-transform: uppercase; letter-spacing: 1.1px; color: #64748b; margin-bottom: 6px; }
  .smv-exec-title { font-size: 19px; font-weight: 800; color: #0f172a; margin-bottom: 18px; }
  .smv-exec-row { display: flex; align-items: flex-start; gap: 14px; border-radius: 8px; padding: 14px 16px; margin-bottom: 10px; }
  .smv-exec-row:last-child { margin-bottom: 0; }
  .smv-exec-row-label { font-weight: 700; font-size: 14px; margin-bottom: 1px; }
  .smv-exec-row-sub { font-size: 12px; color: #64748b; margin-bottom: 6px; }
  .smv-exec-row-items { display: flex; flex-wrap: wrap; gap: 4px 14px; }
  .smv-exec-row-item { font-size: 12.5px; color: #334155; display: flex; align-items: center; gap: 4px; }
  .smv-exec-footer { margin-top: 16px; padding: 12px 16px; background: #fffbeb; border: 1px solid #fcd34d;
    border-radius: 8px; font-size: 13.5px; font-weight: 700; color: #92400e; text-align: center; }
  @media (max-width: 900px) {
    .smv-modecard-body { grid-template-columns: 1fr !important; }
  }
  @media (max-width: 768px) {
    .smv-page { padding: 20px 16px 48px !important; }
    .smv-hero { padding: 24px 20px !important; }
    .smv-hero h1 { font-size: 22px !important; }
    .smv-hero p { font-size: 13.5px !important; }
    .smv-golden { flex-direction: column !important; gap: 10px !important; padding: 14px 16px !important; }
    .smv-concepts { grid-template-columns: 1fr !important; }
    .smv-order-strip { grid-template-columns: 1fr !important; }
    .smv-modecard { padding: 18px 16px !important; }
    .smv-modecard-body { grid-template-columns: 1fr !important; }
    .smv-guide-card { padding: 16px 16px !important; }
    .smv-exec { padding: 18px 16px !important; }
    .smv-qblock-answers { padding-left: 0 !important; }
    .smv-qblock-row { flex-direction: column; gap: 4px; }
  }
`;

/* ── helpers ── */

const Stars = ({ n, max = 5, color }) => (
  <span aria-label={`${n} de ${max}`}>
    {Array.from({ length: max }, (_, i) => (
      <span key={i} style={{ color: i < n ? color : '#d1d5db', fontSize: 14 }}>★</span>
    ))}
  </span>
);

const Tick = ({ ok, accent }) => (
  <span className="smv-tick" style={{ background: ok ? accent : '#dc2626' }}>
    {ok ? '✓' : '✗'}
  </span>
);

const Tag = ({ children, accent }) => (
  <span className="smv-tag" style={{ background: rgba(accent, 0.08), color: accent, border: `1px solid ${rgba(accent, 0.2)}` }}>
    {children}
  </span>
);

const InfoBox = ({ type, children }) => {
  const icons = { info: 'ℹ️', warning: '⚠️', success: '✓', danger: '⛔' };
  return (
    <div className={`smv-infobox smv-infobox-${type || 'info'}`}>
      <span style={{ marginRight: 5 }}>{icons[type] || 'ℹ️'}</span>{children}
    </div>
  );
};

const Feature = ({ ok, accent, children }) => (
  <div className="smv-feature">
    <Tick ok={ok} accent={accent} />
    <span className="smv-feature-text">{children}</span>
  </div>
);

/* ── Mode Card (full-width, 2-column body) ── */
const ModeCard = ({ mode }) => (
  <div className="smv-modecard" style={{ borderTop: `4px solid ${mode.accent}` }}>
    {/* header */}
    <div className="smv-modecard-header">
      <div className="smv-modecard-icon" style={{ background: rgba(mode.accent, 0.08), border: `2px solid ${rgba(mode.accent, 0.2)}` }}>
        {mode.emoji}
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div className="smv-modecard-meta">
          <span className="smv-modecard-num" style={{ color: mode.accent }}>{mode.num}</span>
          <span className="smv-modecard-badge" style={{ background: mode.recBg, color: mode.recColor, border: `1px solid ${mode.recBorder}` }}>
            {mode.recLabel}
          </span>
        </div>
        <h3>{mode.title}</h3>
        <div className="smv-modecard-stars">
          <Stars n={mode.uxStars} color={mode.accent} />
          <span className="smv-modecard-stars-label">{mode.uxLabel}</span>
        </div>
      </div>
    </div>

    <p className="smv-modecard-desc">{mode.description}</p>

    {/* 2-column body */}
    <div className="smv-modecard-body">
      <div className="smv-modecard-left">
        <div className="smv-label" style={{ color: mode.accent }}>Características técnicas</div>
        {mode.features.map((f, i) => <Feature key={i} ok={f.ok} accent={mode.accent}>{f.text}</Feature>)}
        {mode.alerts && mode.alerts.map((a, i) => <InfoBox key={i} type={a.type}>{a.text}</InfoBox>)}
      </div>
      <div className="smv-modecard-right">
        <div className="smv-label" style={{ color: mode.accent }}>Casos de uso ideales</div>
        <div className="smv-tags">
          {mode.useCases.map((uc, i) => <Tag key={i} accent={mode.accent}>{uc}</Tag>)}
        </div>
        <div className="smv-rec-box" style={{ background: rgba(mode.accent, 0.04), border: `1px solid ${rgba(mode.accent, 0.15)}` }}>
          <div className="smv-label" style={{ color: mode.accent }}>Recomendación comercial</div>
          <div className="smv-rec-text" style={{ color: '#1e293b' }}>{mode.recommendation}</div>
        </div>
      </div>
    </div>
  </div>
);

/* ── Comparison Table ── */
const CompTable = () => {
  const cols = [
    { key: 'dia',      label: 'Modo por Día',      emoji: '🕐', accent: C.dia,      rec: 'Primera opción' },
    { key: 'abertura', label: 'Modo por Abertura',  emoji: '🪙', accent: C.abertura, rec: 'Segunda opción' },
    { key: 'horas',    label: 'Modo por Horas',     emoji: '⏱️', accent: C.horas,    rec: 'Evitar vender' },
  ];
  const rows = [
    { label: 'Recomendación',       dia: { v: '✓✓✓ Primera opción', c: '#15803d' }, abertura: { v: '✓✓ Segunda opción', c: '#7c3aed' }, horas: { v: '✗ Evitar vender', c: '#dc2626' } },
    { label: 'Complejidad técnica', dia: { v: '🟢 Baja' }, abertura: { v: '🟡 Media' }, horas: { v: '🔴 Alta' } },
    { label: 'Quick Access (PIN)',  dia: { v: '✓ SÍ', c: '#15803d' }, abertura: { v: '✓ SÍ', c: '#15803d' }, horas: { v: '✗ NO', c: '#dc2626' } },
    { label: 'QR Code / Online',    dia: { v: '✓ SÍ', c: '#15803d' }, abertura: { v: '✓ SÍ', c: '#15803d' }, horas: { v: '✗ NO', c: '#dc2626' } },
    { label: 'Venta anticipada',    dia: { v: '✓ SÍ', c: '#15803d' }, abertura: { v: '✓ SÍ', c: '#15803d' }, horas: { v: '✗ NO', c: '#dc2626' } },
    { label: 'Canales de venta',    dia: { v: 'Pantalla + QR + Online' }, abertura: { v: 'Pantalla + QR + Online' }, horas: { v: 'Solo pantalla táctil' } },
    { label: 'Aperturas permitidas', dia: { v: 'Ilimitadas (24h)' }, abertura: { v: '2 + cortesía' }, horas: { v: 'N/A – slot de tiempo' } },
    { label: 'Teclado digital',     dia: { v: '✓ Activo – PIN', c: '#15803d' }, abertura: { v: '✓ Activo – PIN', c: '#15803d' }, horas: { v: '✗ Inactivo', c: '#dc2626' } },
    { label: 'Rotación taquillas',  dia: { v: 'Baja (1/día)' }, abertura: { v: 'Media-Alta' }, horas: { v: 'Alta (por slots)' } },
    { label: 'Liberación',          dia: { v: 'Night Scan nocturno' }, abertura: { v: 'Tras 2ª abertura' }, horas: { v: 'Al finalizar slot' } },
    { label: 'Tiempo de cortesía',  dia: { v: 'No aplica' }, abertura: { v: '✓ SÍ (config.)', c: '#15803d' }, horas: { v: 'Penalización' } },
    { label: 'Cobro',               dia: { v: 'Por día completo' }, abertura: { v: 'Por 2 aperturas' }, horas: { v: 'Por slot de tiempo' } },
    { label: 'Experiencia usuario', dia: { v: '★★★★★ Excelente', c: C.dia }, abertura: { v: '★★★★☆ Muy buena', c: C.abertura }, horas: { v: '★★☆☆☆ Regular', c: C.horas } },
    { label: 'Nivel de venta',      dia: { v: '★★★★★ Máxima', c: C.dia }, abertura: { v: '★★★★☆ Frecuente', c: C.abertura }, horas: { v: '★☆☆☆☆ Mínima', c: C.horas } },
    { label: 'Posicionamiento',     dia: { v: 'Estándar del sector' }, abertura: { v: 'Diferenciador Vacway' }, horas: { v: 'Solo Vacway' } },
    { label: 'Casos de referencia', dia: { v: 'Port Aventura, Ferrari Land' }, abertura: { v: 'Aquarium BCN, Caldea' }, horas: { v: 'Estaciones, aeropuertos' } },
    { label: 'Argumento principal', dia: { v: 'Máxima comodidad' }, abertura: { v: 'Rotación + UX' }, horas: { v: 'Control horario' } },
  ];
  return (
    <div className="smv-table-wrap">
      <table className="smv-table">
        <thead>
          <tr>
            <th style={{ borderBottom: '2px solid #e2e8f0', background: '#f8fafc', color: '#64748b', textTransform: 'uppercase', letterSpacing: 0.8 }}>
              Característica
            </th>
            {cols.map(col => (
              <th key={col.key} style={{ borderBottom: `3px solid ${col.accent}`, background: rgba(col.accent, 0.04), minWidth: 180 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
                  <span style={{ fontSize: 18 }}>{col.emoji}</span>
                  <div>
                    <div style={{ fontSize: 13, fontWeight: 800, color: col.accent }}>{col.label}</div>
                    <div style={{ fontSize: 11, fontWeight: 600, color: '#64748b' }}>{col.rec}</div>
                  </div>
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={i} style={{ background: i % 2 === 0 ? '#fff' : '#fafbfc' }}>
              <td style={{ fontWeight: 600, color: '#475569', whiteSpace: 'nowrap', borderBottom: '1px solid #f1f5f9' }}>
                {row.label}
              </td>
              {cols.map(col => {
                const cell = row[col.key];
                return (
                  <td key={col.key} style={{ color: cell.c || '#1e293b', fontWeight: cell.c ? 700 : 400, borderBottom: '1px solid #f1f5f9' }}>
                    {cell.v}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

/* ── Data ── */
const MODES = [
  {
    accent: C.dia, emoji: '🕐', num: 'Modo 1',
    title: 'Alquiler por día (24 horas)',
    recLabel: '✓✓✓ Primera opción',
    recBg: '#f0fdf4', recColor: '#15803d', recBorder: '#bbf7d0',
    uxStars: 5, uxLabel: 'Experiencia excelente · Nivel de venta máximo',
    description: 'La taquilla se asigna a un usuario durante 24 horas o hasta el cierre del establecimiento. El cliente puede abrir y cerrar las veces que necesite con su código PIN. Es el modo estándar del mercado: toda la competencia lo ofrece, y es el más vendido.',
    features: [
      { ok: true,  text: 'QUICK ACCESS: el usuario abre directamente con PIN en el teclado digital, sin volver a la pantalla.' },
      { ok: true,  text: 'Aperturas ilimitadas durante todo el período de uso.' },
      { ok: true,  text: 'Night Scan automático: resetea el sistema por la noche (hora configurable) y libera todas las taquillas.' },
      { ok: true,  text: 'Compatible con QR CODE: venta online, venta anticipada y reservas desde la web del cliente.' },
      { ok: true,  text: 'Todos los canales de venta: pantalla táctil VLK06 + QR online + venta anticipada + integración ERP.' },
    ],
    alerts: [
      { type: 'warning', text: 'Una vez asignada, la taquilla NO puede reasignarse a otro cliente hasta el reseteo nocturno. Si el cliente se va antes de tiempo, la taquilla queda bloqueada hasta el día siguiente.' },
      { type: 'info', text: 'Night Scan: si el usuario deja la taquilla libre voluntariamente, tampoco se pone a la venta hasta el siguiente Night Scan. Punto clave a explicar al cliente B2B.' },
    ],
    useCases: ['Parques temáticos', 'Parques acuáticos', 'Estaciones de esquí', 'Gimnasios', 'Centros deportivos', 'Port Aventura', 'Ferrari Land'],
    recommendation: '✓ Primera opción siempre. Recomendar en el 80% de los casos. Máxima satisfacción del cliente final, menos complicaciones técnicas y permite venta multicanal (online, QR, anticipada). La gestión nocturna automática elimina intervención manual.',
  },
  {
    accent: C.abertura, emoji: '🪙', num: 'Modo 2',
    title: 'Alquiler por abertura (2 aperturas)',
    recLabel: '✓✓ Segunda opción',
    recBg: '#f5f3ff', recColor: '#7c3aed', recBorder: '#ddd6fe',
    uxStars: 4, uxLabel: 'Experiencia muy buena · Venta frecuente',
    description: 'El cliente paga por dos aperturas: una para dejar sus pertenencias y otra para recogerlas. Existe un tiempo de cortesía configurable entre ambas aperturas. Tras la segunda apertura la taquilla se libera automáticamente para el siguiente cliente.',
    features: [
      { ok: true,  text: 'QUICK ACCESS: el usuario sí puede usar el código PIN en el teclado digital.' },
      { ok: true,  text: 'Compatible con QR CODE: venta online, anticipada y desde pantalla táctil.' },
      { ok: true,  text: 'Canales de venta completos: pantalla táctil + QR online + venta anticipada.' },
      { ok: true,  text: 'Ticket impreso con número de taquilla y PIN (ej: "Taquilla 25 – PIN 1234").' },
      { ok: true,  text: 'Tiempo de cortesía configurable entre aperturas (ej: 10 min.) para que el cliente pueda re-entrar si olvidó algo.' },
      { ok: true,  text: 'Mayor rotación que el modo por día: la taquilla se libera tras la 2ª abertura.' },
    ],
    alerts: [
      { type: 'success', text: 'El tiempo de cortesía mejora la UX: evita penalizar al cliente si olvidó la crema solar o el móvil. Es configurable por el cliente B2B (5, 10 o 15 minutos).' },
    ],
    useCases: ['Parques acuáticos', 'Balnearios y spas', 'Eventos y festivales', 'Museos', 'Atracciones turísticas', 'Port Aventura', 'Aquarium Barcelona', 'Caldea'],
    recommendation: '✓ Segunda opción recomendada cuando el cliente necesita optimizar rotación pero quiere mantener buena experiencia de usuario. Especialmente recomendado para parques acuáticos, spas y atracciones donde el visitante solo necesita acceder 2 veces.',
  },
  {
    accent: C.horas, emoji: '⏱️', num: 'Modo 3',
    title: 'Alquiler por horas (slots de tiempo)',
    recLabel: '✗ Evitar vender',
    recBg: '#fef2f2', recColor: '#dc2626', recBorder: '#fecaca',
    uxStars: 2, uxLabel: 'Experiencia regular · Venta mínima',
    description: 'La taquilla se alquila por franjas horarias predefinidas (slots fijos). El cliente paga por el tiempo que necesita y solo puede operar desde la pantalla táctil. Solo Vacway ofrece este modo en el mercado, pero NO es el producto estrella.',
    features: [
      { ok: false, text: 'NO QUICK ACCESS: el teclado digital de la taquilla queda inactivo. El cliente no puede abrir de forma autónoma.' },
      { ok: false, text: 'NO QR CODE: no permite venta online ni venta anticipada.' },
      { ok: false, text: 'Solo pantalla táctil: todo el proceso debe hacerse desde el módulo VLK06.' },
      { ok: false, text: 'La puerta se abre desde la pantalla, no desde el teclado de la taquilla.' },
      { ok: true,  text: 'Slots configurables: 20 min, 1h, 2h, etc. (requieren reconfiguración para cambiarlos).' },
      { ok: true,  text: 'Penalización automática por exceso de tiempo (con tiempo de cortesía configurable).' },
      { ok: true,  text: 'Alta rotación: liberación automática al vencer el slot.' },
    ],
    alerts: [
      { type: 'danger', text: 'El teclado digital de cada taquilla queda inactivo, desperdiciando hardware. Mayor dependencia de la pantalla: si falla, los clientes no pueden acceder.' },
      { type: 'warning', text: 'Configuración técnica compleja. Requiere más tiempo de setup y más soporte post-venta que los otros modos.' },
    ],
    useCases: ['Centros comerciales', 'Estaciones de tren/bus', 'Aeropuertos (consignas)', 'Gimnasios pases sueltos', 'Museos'],
    recommendation: '⚠️ NO recomendar activamente. Ofrecer SOLO si el cliente lo solicita expresamente y tiene un caso de uso muy claro con alta rotación. Intentar siempre reconducir hacia el modo por abertura, que ofrece rotación similar con UX superior.',
  },
];

const QUESTIONS = [
  { question: '¿Cuánto tiempo permanecen los visitantes en la instalación?', answers: [
    { condition: '< 2 horas', accent: C.abertura, recommendation: 'Modo por abertura (o por horas como último recurso).' },
    { condition: '2 – 4 horas', accent: C.abertura, recommendation: 'Modo por abertura.' },
    { condition: '> 4 horas', accent: C.dia, recommendation: 'Modo por día (24h).' },
  ]},
  { question: '¿Necesitan los clientes acceder varias veces a la taquilla?', answers: [
    { condition: 'Sí, frecuente', accent: C.dia, recommendation: 'Modo por día.' },
    { condition: 'Sí, 1–2 veces', accent: C.abertura, recommendation: 'Modo por abertura.' },
    { condition: 'No', accent: C.dia, recommendation: 'Cualquier modo – recomendar por día por defecto.' },
  ]},
  { question: '¿Qué nivel de rotación necesita el cliente en las taquillas?', answers: [
    { condition: 'Baja (1/día)', accent: C.dia, recommendation: 'Modo por día.' },
    { condition: 'Media (2–3/día)', accent: C.abertura, recommendation: 'Modo por abertura.' },
    { condition: 'Alta (4+/día)', accent: C.horas, recommendation: 'Modo por horas como último recurso.' },
  ]},
  { question: '¿Quiere ofrecer venta online y anticipada?', answers: [
    { condition: 'Sí', accent: C.dia, recommendation: 'Modo por día o por abertura (ambos compatibles con QR y online).' },
    { condition: 'No', accent: '#64748b', recommendation: 'Cualquier modo sirve.' },
  ]},
];

/* ── Main View ── */
const SalesModesView = () => (
  <div className="smv-page">
    <style>{CSS}</style>

    {/* HERO */}
    <div className="smv-hero">
      <div style={{ position: 'absolute', right: -30, top: -30, width: 220, height: 220, borderRadius: '50%', background: 'rgba(255,255,255,0.06)', pointerEvents: 'none' }} />
      <div className="smv-hero-badge">Guía Interna · Equipo Comercial VACWAY</div>
      <h1>Modos de venta · Taquillas VACWAYLockers</h1>
      <p>Documento interno para el equipo de ventas. Describe los tres modos de funcionamiento, sus diferencias técnicas y la estrategia comercial recomendada para asesorar correctamente a cada cliente B2B.</p>
      <div className="smv-hero-actions">
        <Link to="/sales-modes-quiz" className="smv-hero-btn">📝 Test de conocimientos</Link>
      </div>
    </div>

    {/* GOLDEN RULE */}
    <div className="smv-golden">
      <span className="smv-golden-icon">⚙️</span>
      <div>
        <div className="smv-golden-label">Regla de oro del sistema</div>
        <div className="smv-golden-title">1 ORDENADOR = 1 MODO DE USO</div>
        <div className="smv-golden-text">Cada pantalla VLK06 o sistema QR solo puede configurarse para un único modo. No se pueden mezclar modos en la misma pantalla. Un ordenador gestiona entre 100–120 taquillas y requiere 1 licencia de software independiente.</div>
      </div>
    </div>

    {/* 1 · CONCEPTOS */}
    <div style={{ marginBottom: 36 }}>
      <h2 className="smv-section-title">1 · Conceptos básicos</h2>
      <p className="smv-section-sub">Asegúrate de que el cliente B2B entiende estos conceptos antes de presentar los modos.</p>
      <div className="smv-concepts">
        {[
          { icon: '🖥️', title: '¿Qué es un "ordenador" Vacway?', body: 'Puede ser una pantalla táctil integrada en un módulo VLK06 (punto de venta físico) o un sistema QR (canal online en el móvil del cliente). Cada uno gestiona entre 100–120 taquillas y requiere su propia licencia de software.' },
          { icon: '📐', title: 'Dimensionamiento del sistema', body: '1 ordenador → 100–120 taquillas → 1 licencia. En instalaciones grandes se combinan varios ordenadores, cada uno con su modo de uso. Los modos pueden ser distintos entre ordenadores de la misma instalación.' },
          { icon: '🔑', title: 'Tipos de licencia de software', body: 'BÁSICA: gestión estándar. PRO: QR, venta anticipada, venta online e integración ERP. PDA/PC: venta desde tablets, PC de recepción o integración directa con la web del cliente.' },
        ].map((card, i) => (
          <div key={i} className="smv-concept-card">
            <div className="smv-concept-icon">{card.icon}</div>
            <div className="smv-concept-title">{card.title}</div>
            <div className="smv-concept-body">{card.body}</div>
          </div>
        ))}
      </div>
    </div>

    {/* ORDER STRIP */}
    <div className="smv-order-strip">
      {[
        { n: '1', emoji: '🕐', label: 'Modo por día', sub: 'Recomendar en el 80% de los casos', color: C.dia },
        { n: '2', emoji: '🪙', label: 'Modo por abertura', sub: 'Alta rotación con buena UX', color: C.abertura },
        { n: '3', emoji: '⏱️', label: 'Modo por horas', sub: 'Solo si el cliente lo pide', color: C.horas },
      ].map(item => (
        <div key={item.n} className="smv-order-item" style={{ background: rgba(item.color, 0.05), border: `1px solid ${rgba(item.color, 0.15)}` }}>
          <div className="smv-order-num" style={{ background: item.color }}>{item.n}</div>
          <div>
            <div className="smv-order-label" style={{ color: item.color }}>
              <span>{item.emoji}</span> {item.label}
            </div>
            <div className="smv-order-sub">{item.sub}</div>
          </div>
        </div>
      ))}
    </div>

    {/* 2 · MODOS */}
    <div style={{ marginBottom: 36 }}>
      <h2 className="smv-section-title">2 · Los tres modos de uso</h2>
      <p className="smv-section-sub">Descripción completa de cada modo con características técnicas, limitaciones y argumentos de venta.</p>
      <div className="smv-modes-list">
        {MODES.map((mode, i) => <ModeCard key={i} mode={mode} />)}
      </div>
    </div>

    {/* 3 · TABLA */}
    <div style={{ marginBottom: 36 }}>
      <h2 className="smv-section-title">3 · Tabla comparativa</h2>
      <p className="smv-section-sub">Referencia rápida para comparar los tres modos frente al cliente.</p>
      <CompTable />
    </div>

    {/* 4 · GUÍA */}
    <div style={{ marginBottom: 36 }}>
      <h2 className="smv-section-title">4 · Guía de venta</h2>
      <p className="smv-section-sub">Preguntas clave para identificar el modo adecuado y estrategia de presentación.</p>

      <div className="smv-guide-card">
        <div className="smv-guide-title">Preguntas clave para identificar el modo adecuado</div>
        {QUESTIONS.map((q, i) => (
          <div key={i} className="smv-qblock">
            <div className="smv-qblock-q">🔹 {q.question}</div>
            <div className="smv-qblock-answers">
              {q.answers.map((a, j) => (
                <div key={j} className="smv-qblock-row">
                  <span className="smv-qblock-cond" style={{ background: a.accent }}>{a.condition}</span>
                  <span className="smv-qblock-rec">→ {a.recommendation}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className="smv-guide-card">
        <div className="smv-guide-title">Estrategia de presentación al cliente</div>
        {[
          { n: 1, accent: C.dia, title: 'Presentar primero el modo por día (opción por defecto)', text: '"Este es nuestro modo más popular, utilizado en los principales parques de Europa. Ofrece máxima comodidad al usuario final y permite venta anticipada online..."' },
          { n: 2, accent: C.abertura, title: 'Si necesita más rotación → modo por abertura', text: '"Para optimizar rotación sin sacrificar experiencia de usuario, tenemos el modo por abertura, como el de Port Aventura y Aquarium Barcelona..."' },
          { n: 3, accent: C.horas, title: 'Solo si lo pide expresamente → modo por horas', text: '"También tenemos un modo por slots de tiempo, aunque tiene limitaciones técnicas importantes que debes conocer antes de decidir..."' },
        ].map((step, i) => (
          <div key={i} className="smv-step">
            <div className="smv-step-num" style={{ background: step.accent }}>{step.n}</div>
            <div style={{ minWidth: 0 }}>
              <div className="smv-step-title" style={{ color: step.accent }}>{step.title}</div>
              <div className="smv-step-text">{step.text}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="smv-danger-box">
        <div className="smv-danger-title">⛔ Argumentos para desaconsejar el modo por horas</div>
        {[
          'Pierde el Quick Access: el cliente ya no puede abrir la taquilla con el PIN del teclado, lo que empeora visiblemente la experiencia.',
          'No permite venta online ni anticipada, limitando los canales de ingresos del cliente.',
          'Configuración más compleja y mayor necesidad de soporte técnico post-venta.',
          'El teclado digital de cada taquilla queda inactivo, desperdiciando hardware instalado.',
          'El modo por abertura ofrece rotación similar pero con mucho mejor experiencia de usuario.',
        ].map((arg, i) => (
          <div key={i} className="smv-danger-item">
            <span className="smv-danger-arrow">→</span>
            <span className="smv-danger-text">{arg}</span>
          </div>
        ))}
      </div>
    </div>

    {/* 5 · RESUMEN */}
    <div className="smv-exec">
      <div className="smv-exec-label">5 · Resumen ejecutivo</div>
      <div className="smv-exec-title">Orden de preferencia de venta</div>
      {[
        { n: '1', color: C.dia, label: 'Modo por día (24h)', pct: '→ 80% de los casos', items: ['Máxima satisfacción del cliente final', 'Menos complicaciones técnicas', 'Venta multicanal: online, QR, anticipada'] },
        { n: '2', color: C.abertura, label: 'Modo por abertura', pct: '→ Cuando necesita optimizar rotación', items: ['Ideal para parques acuáticos, spas, balnearios', 'Mantiene Quick Access y venta online', 'Refs: Port Aventura, Aquarium BCN, Caldea'] },
        { n: '3', color: C.horas, label: 'Modo por horas', pct: '→ Solo si lo pide expresamente', items: ['Intentar reconducir siempre a modo por abertura', 'Configuración compleja, más soporte post-venta', 'Experiencia de usuario inferior'] },
      ].map(item => (
        <div key={item.n} className="smv-exec-row" style={{ background: rgba(item.color, 0.04), borderLeft: `4px solid ${item.color}` }}>
          <div className="smv-order-num" style={{ background: item.color, width: 30, height: 30, fontSize: 14 }}>{item.n}</div>
          <div style={{ minWidth: 0, flex: 1 }}>
            <div className="smv-exec-row-label" style={{ color: item.color }}>{item.label}</div>
            <div className="smv-exec-row-sub">{item.pct}</div>
            <div className="smv-exec-row-items">
              {item.items.map((it, j) => (
                <span key={j} className="smv-exec-row-item">
                  <span style={{ color: item.color, fontWeight: 900 }}>·</span> {it}
                </span>
              ))}
            </div>
          </div>
        </div>
      ))}
      <div className="smv-exec-footer">
        ⚠️ RECORDATORIO: 1 ORDENADOR = 1 MODO DE USO · No se pueden mezclar modos en la misma pantalla
      </div>
    </div>
  </div>
);

export default SalesModesView;
